import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=04aab1ad&scoped=true&"
import script from "./TopMenu.vue?vue&type=script&lang=ts&"
export * from "./TopMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TopMenu.vue?vue&type=style&index=0&id=04aab1ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aab1ad",
  null
  
)

export default component.exports